import { Badge } from "../../../../components/ui/common/badge";
import { IngredientDetailsFormatter } from "../services/IngredientDetailsFormatter";
import { IngredientDetailsViewModel } from "../types/ingredientDetailsView.types";

interface IngredientDetailsHeaderProps {
  vm: IngredientDetailsViewModel;
}

/**
 * Chip row shown under the ingredient name in the drawer header — Ingredient
 * Type (RAW/PROCESSED), Data Type (Generic/Supplier/...) and, when present,
 * the supplier-entered Product ID. Passed as `TailwindSideModal`'s
 * `titleMeta`, matching the `ProductDetailsModal`/`SupplierDetailsModal`
 * convention instead of the old disabled Ingredient Name / Supplier Name
 * input boxes (those two fields now live in `IngredientOverviewCard`).
 */
const IngredientDetailsHeader = ({ vm }: IngredientDetailsHeaderProps) => {
  const details = vm.ingredientDetails?.supplierIngredientDetails;
  const dataTypeLabel = IngredientDetailsFormatter.dataTypeLabel(details?.data_type);
  const productId = details?.product_id;

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      {details?.ingredient_type ? (
        <Badge variant="outline" className="tw-rounded-full tw-text-[10px] tw-font-semibold tw-uppercase">
          {details.ingredient_type}
        </Badge>
      ) : null}
      {dataTypeLabel ? (
        <Badge variant="secondary" className="tw-rounded-full tw-text-[10px] tw-font-semibold">
          {dataTypeLabel}
        </Badge>
      ) : null}
      {productId ? (
        <span className="tw-font-mono tw-text-xs tw-text-muted-foreground">{productId}</span>
      ) : null}
    </div>
  );
};

export default IngredientDetailsHeader;
